import { type ReactNode } from 'react'
import { type SxProps, type Theme } from '@mui/material'

import { type IconName } from '~components/icons/iconMapping'
import { type BannerType } from '~components/internal'
import { type SemanticIconName } from '~components/internal/Icon'
import { typography } from '~tokens/internal'

export interface BannerConfig {
  id: string
  message: ReactNode
  type: BannerType
  dismissible: boolean
  subtitle?: string
  startDate?: Date | string
  endDate?: Date | string
  links?: Array<{
    text: string
    url: string
  }>
  icon?: SemanticIconName | IconName
  sx?: SxProps<Theme>
  reappearAfterMonths?: number
  showLastDaysOfMonth?: number
  showFirstDaysOfMonth?: number
}

export const generateHash = (str: string): string => {
  let hash = 0
  if (str.length === 0) return hash.toString()
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return 'banner_' + Math.abs(hash).toString(16)
}

export const BANNERS: BannerConfig[] = [
  {
    id: 'customer-survey-2',
    message: 'Want to help create our product? Give us feedback on new features!',
    type: 'feedback',
    dismissible: true,
    endDate: new Date(2026, 3, 1),
    reappearAfterMonths: 3,
    showFirstDaysOfMonth: 21,
    icon: 'rocketLaunch',
    subtitle: 'Time: 10 Minutes',
    sx: {
      fontWeight: typography.fontWeight.bold,
      fontSize: typography.fontSize.sm,
    },
    links: [
      {
        text: 'Give us feedback on new features!',
        url: 'https://www.figma.com/proto/vEvJlvbI1QeWZrYXMoR5Ft/Untitled?node-id=1-19&t=oaTfUvUCz8RmmwB4-1&scaling=min-zoom&content-scaling=fixed&page-id=1%3A18',
      },
    ],
  },
  {
    id: 'terms-of-service-2',
    message:
      "Our Terms of Service and Privacy Policy have been updated. By continuing, you're agreeing to our Terms of Service and Privacy Policy.",
    type: 'info',
    dismissible: true,
    endDate: new Date(2025, 12, 1, 0, 0, 0),
    links: [
      {
        text: 'Terms of Service',
        url: 'https://www.polimorphic.com/terms-of-service',
      },
      {
        text: 'Privacy Policy',
        url: 'https://www.polimorphic.com/privacy-policy',
      },
    ],
  },
  // Example Banner:
  // {
  //   id: 'feature-announcement',
  //   message: "We've launched exciting new features! Check out our updated dashboard.",
  //   type: 'success',
  //   dismissible: true,
  //   startDate: new Date(2025, 4, 5, 9, 0, 0), // May 5, 2025 at 9:00 AM
  //   endDate: new Date(2025, 4, 5, 17, 0, 0), // May 5, 2025 at 5:00 PM
  // },
  {
    id: 'outbound-comms-launch',
    message: 'Just Launched: Outbound Communications for Government',
    type: 'info',
    dismissible: true,
    icon: 'rocketLaunch',
    links: [
      {
        text: 'Outbound Communications for Government',
        url: 'https://www.polimorphic.com/outbound-comms-demo-request',
      },
    ],
    startDate: new Date(2026, 4, 5, 9, 0, 0),
    endDate: new Date(2026, 5, 10, 9, 0, 0),
  },
  {
    id: 'customer-experience-survey',
    message:
      'Tell us what you think! Your feedback is going to help us improve our products and better support teams like yours.',
    type: 'feedback',
    icon: 'info',
    dismissible: true,
    reappearAfterMonths: 2,
    links: [
      {
        text: 'Tell us what you think',
        url: 'https://app.userevidence.com/surveys/e322261e-4cf5-48fe-b2cb-549920579c36/share',
      },
    ],
    startDate: new Date(2026, 1, 0, 0, 0, 0),
    endDate: new Date(2026, 8, 30, 0, 0, 0),
    showLastDaysOfMonth: 7,
  },
]
